import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Feather } from 'lucide-react';
import { WorldPageHeader } from '../../components/world/WorldPageHeader';
import { CopyLinkButton } from '../../components/guide/CopyLinkButton';
import { ValidationLegend } from '../../components/progression/ValidationBadge';
import { ClassicRecipeLabel } from '../../components/progression/RecipeSteps';
import { recipes, recipeGroups, recipePath } from '../../data/guide/recipes';
import { PetObtainRoutes } from '../../components/progression/PetObtainRoutes';

/** Índice de combinaciones fuera de alas y capas: mascotas, monturas y entradas de eventos. */
export function CombinationsGuide() {
  useEffect(() => {
    document.title = 'Combinaciones · Guía MU Vanguard';
  }, []);
  return <div className="space-y-8 md:space-y-10" data-id="element-2580" data-mp="vie5riuk337g">
      <WorldPageHeader crumbs={[{
      label: 'Guía',
      to: '/guia'
    }, {
      label: 'Combinaciones'
    }]} eyebrow="Guía interactiva" title="Combinaciones" data-id="element-2581" data-mp="vhmm96e8gvxj">
        <p className="mt-2 max-w-2xl text-sm text-gray-300 md:text-base" data-id="element-2582" data-mp="1jtggr4j00wlj">Cómo crear mascotas, monturas y entradas de eventos: materiales, NPC, pasos y dónde conseguir cada ingrediente.</p>
        <div className="mt-3 flex flex-wrap items-center gap-2" data-id="element-2583" data-mp="1at1t3yikb5ev">
          <ClassicRecipeLabel data-id="element-2584" data-mp="1ar75gcfwoz73" />
          <CopyLinkButton data-id="element-2585" data-mp="15txeutgs6hho" />
        </div>
      </WorldPageHeader>

      {recipeGroups.map(g => <section key={g.id} id={g.id} aria-labelledby={`h-${g.id}`} className="scroll-mt-24" data-id="element-2586" data-mp="10uue3l7u2xfi">
          <h2 id={`h-${g.id}`} className="font-cinzel text-lg font-bold text-white md:text-xl" data-id="element-2587" data-mp="w45mm5w5m0gd">{g.title}</h2>
          <p className="mt-1 text-sm text-gray-400" data-id="element-2588" data-mp="s2ajqwykrf0h">{g.description}</p>
          <ul className="mt-3 grid gap-2 sm:grid-cols-2 lg:grid-cols-3" data-id="element-2589" data-mp="s0g0dn2ybuyi">
            {recipes.filter(r => r.group === g.id).map(r => <li key={r.id} data-id="element-2590" data-mp="i4mcx8np2h1y">
                <Link to={recipePath(r.id)} className="group flex h-full items-center gap-3 rounded-2xl border border-white/10 bg-[#0A1628] p-3.5 transition-colors duration-150 hover:border-[#D4AF37]/50 md:p-4" data-id="element-2591" data-mp="i3utew7dg9s1">
                  <span className="min-w-0 flex-1" data-id="element-2592" data-mp="3gcl7nulox0v">
                    <span className="block font-cinzel font-bold text-white" data-id="element-2593" data-mp="8h0lz18mss8a">{r.shortTitle}</span>
                    <span className="mt-0.5 block text-xs text-gray-400 md:text-sm" data-id="element-2594" data-mp="3qmvirlp2qhtp">{r.summary}</span>
                    <span className="mt-1 block text-[11px] text-gray-500" data-id="element-2595" data-mp="3un6yql6hrtyu">{r.machine ?? 'Chaos Machine'}</span>
                  </span>
                  <ArrowRight className="h-4 w-4 shrink-0 text-gray-500 group-hover:text-[#D4AF37]" aria-hidden="true" data-id="element-2596" data-mp="m8ou6tfrewjz" />
                </Link>
              </li>)}
          </ul>
        </section>)}

      <Link to="/guia/alas" className="group flex items-center gap-3 rounded-2xl border border-[#D4AF37]/30 bg-[#0A1628] p-4 hover:border-[#D4AF37]/60" data-id="element-2597" data-mp="ddqzphwyrbqj">
        <Feather className="h-5 w-5 shrink-0 text-[#D4AF37]" aria-hidden="true" data-id="element-2598" data-mp="155yhilo7gu6i" />
        <span className="flex-1" data-id="element-2599" data-mp="19y9hfoiy4fz2">
          <span className="block font-cinzel font-bold text-white" data-id="element-2600" data-mp="19yj5v7ocef2n">Alas, capas y armas Chaos</span>
          <span className="block text-sm text-gray-400" data-id="element-2601" data-mp="2umtyk71hcrth">Arma Chaos, alas Evo 1–3, capas y Condor Feather.</span>
        </span>
        <ArrowRight className="h-4 w-4 text-[#D4AF37]" aria-hidden="true" data-id="element-2602" data-mp="2pmz9m919mcb2" />
      </Link>

      <PetObtainRoutes data-id="element-2603" data-mp="34d6grslto8wg" />

      <p className="text-sm text-gray-400" data-id="element-2604" data-mp="2zev8vnf388gv">Paquetes de joyas: están identificados en el catálogo, pero falta documentar cómo se arman y cuántas joyas lleva cada uno.</p>
      <ValidationLegend data-id="element-2605" data-mp="2bpj3yzqsmmkd" />
    </div>;
}